import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { BufferedSinkJsonWriter1xl4ankftitqq as BufferedSinkJsonWriter } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/BufferedSinkJsonWriter.mjs';
import { writeAny16i13331zbqlc as writeAny } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonWriters.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_AnyAdapterx2g0krnqn0y9 as get_AnyAdapter } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { BufferedSourceJsonReader1eguw7qhrwt7p as BufferedSourceJsonReader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/BufferedSourceJsonReader.mjs';
import { Key_getInstance1eahaybkym4fk as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var WsProtocolClass;
function WsProtocol() {
  if (WsProtocolClass === VOID) {
    class $ {
      constructor(webSocketConnection, listener) {
        this.o69_1 = webSocketConnection;
        this.p69_1 = listener;
      }
      e6a(_this__u8e3s4) {
        // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
        var buffer = new (Buffer())();
        var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
        writeAny($this$buildJsonByteString, _this__u8e3s4);
        return buffer.h3w();
      }
      f6a(_this__u8e3s4) {
        // Inline function 'com.apollographql.apollo.api.json.buildJsonString' call
        var buffer = new (Buffer())();
        var $this$buildJsonString = new (BufferedSinkJsonWriter())(buffer, null);
        writeAny($this$buildJsonString, _this__u8e3s4);
        return buffer.l3w();
      }
      g6a(_this__u8e3s4) {
        var tmp;
        try {
          var tmp_0 = get_AnyAdapter().t3x(new (BufferedSourceJsonReader())((new (Buffer())()).v3w(_this__u8e3s4)), Key_getInstance().h45_1);
          tmp = isInterface(tmp_0, KtMap()) ? tmp_0 : null;
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Exception()) {
            var e = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
          tmp = tmp_1;
        }
        return tmp;
      }
      h6a(messageMap) {
        this.o69_1.u6b(this.e6a(messageMap));
      }
      i6a(messageMap) {
        this.o69_1.j69(this.f6a(messageMap));
      }
      x69(messageMap, frameType) {
        switch (frameType.w1_1) {
          case 0:
            this.i6a(messageMap);
            break;
          case 1:
            this.h6a(messageMap);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
      }
      *q69($completion) {
        while (true) {
          var map = this.g6a(yield* this.o69_1.v6b($completion));
          if (!(map == null)) {
            return map;
          }
        }
      }
      *j6a($completion) {
        try {
          while (true) {
            this.y69(yield* this.q69($completion));
          }
        } catch ($p) {
          if ($p instanceof CancellationException()) {
            var e = $p;
            throw e;
          } else {
            if ($p instanceof Exception()) {
              var e_0 = $p;
              this.p69_1.j6b(e_0);
            } else {
              throw $p;
            }
          }
        }
        return Unit_instance;
      }
      l6() {
        this.o69_1.l6();
      }
    }
    initMetadataForClass($, 'WsProtocol', VOID, VOID, VOID, [0]);
    WsProtocolClass = $;
  }
  return WsProtocolClass;
}
var WsFrameType_Text_instance;
var WsFrameType_Binary_instance;
var WsFrameType_entriesInitialized;
function WsFrameType_initEntries() {
  if (WsFrameType_entriesInitialized)
    return Unit_instance;
  WsFrameType_entriesInitialized = true;
  WsFrameType_Text_instance = new (WsFrameType())('Text', 0);
  WsFrameType_Binary_instance = new (WsFrameType())('Binary', 1);
}
var WsFrameTypeClass;
function WsFrameType() {
  if (WsFrameTypeClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'WsFrameType');
    WsFrameTypeClass = $;
  }
  return WsFrameTypeClass;
}
function WsFrameType_Text_getInstance() {
  WsFrameType_initEntries();
  return WsFrameType_Text_instance;
}
//region block: exports
export {
  WsProtocol as WsProtocol2u70gp1eq7nu9,
  WsFrameType_Text_getInstance as WsFrameType_Text_getInstancen453b7508b2k,
};
//endregion

//# sourceMappingURL=WsProtocol.mjs.map
